import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { HttpClientService } from '../implementacion/http-client.service';


@Injectable({
    providedIn: 'root'
  })

export class PerfilService {
  constructor( private http: HttpClientService ) { }
  IdPerfil: number;

  getConfigPerfil(idUsuario: number,idPerfil: number) {
    return this.http.get(`${environment.apiScar}Cuenta/DetalleInicio?idUsuario=${idUsuario}&idPerfil=${idPerfil}`)
      .pipe(map(response => response));
  }
}
